import React, { useCallback, useEffect, useMemo, useState } from "react";

import { ArrowLeft, Eye, EyeOff, Plus, Search, X, } from "lucide-react";

import I from "../component/Icon";

import apiService from "../services/apiService";



const EMPTY_FORM = {

  firstName: "",

  middleName: "",

  lastName: "",

  email: "",

  mobile: "",

  role: "",

  dob: "",

  profilePic: "",

  password: "",

  confirmPassword: "",

};



const PAGE_SIZE = 10;



const GET_PAGINATED_USERS_API =

  "User/getPaginatedUser";



const GET_ALL_USER_ROLES_API =

  "UserRole/getAllUserRoles";



const formatUserDate = (value) => {

  if (!value) return "";



  const raw = String(value);



  if (/^\d{2}-\d{2}-\d{4}$/.test(raw)) {

    return raw;

  }



  const datePart = raw.split("T")[0];



  if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {

    return datePart.split("-").reverse().join("-");

  }



  const date = new Date(value);



  if (!Number.isNaN(date.getTime())) {

    const day = String(date.getDate()).padStart(2, "0");

    const month = String(date.getMonth() + 1).padStart(2, "0");

    const year = date.getFullYear();



    return `${day}-${month}-${year}`;

  }



  return raw;

};



const normalizeUser = (user) => {

  const activeValue =

    user?.isActive ??

    user?.IsActive ??

    user?.active ??

    user?.Active ??

    false;



  return {

    ...user,



    id:

      user?.id ??

      user?.Id ??

      user?.userId ??

      user?.UserId,



    firstName:

      user?.firstName ??

      user?.FirstName ??

      "",



    middleName:

      user?.middleName ??

      user?.MiddleName ??

      "",



    lastName:

      user?.lastName ??

      user?.LastName ??

      "",



    email:

      user?.email ??

      user?.Email ??

      "",



    mobile:

      user?.mobile ??

      user?.Mobile ??

      user?.mobileNo ??

      user?.MobileNo ??

      "",



    dob: formatUserDate(

      user?.dob ??

      user?.Dob ??

      user?.DOB ??

      user?.dateOfBirth ??

      user?.DateOfBirth ??

      user?.birthDate ??

      user?.BirthDate

    ),



    roleId:

      user?.roleId ??

      user?.RoleId ??

      user?.role ??

      user?.Role ??

      "",



    role:

      user?.roleName ??

      user?.RoleName ??

      user?.userRoleName ??

      user?.UserRoleName ??

      "",



    profilePic:

      user?.profilePic ??

      user?.ProfilePic ??

      "",



    active:

      activeValue === true ||

      Number(activeValue) === 1 ||

      String(activeValue).toLowerCase() === "true",

  };

};



export default function UserListPage() {

  const [users, setUsers] = useState([]);

  const [search, setSearch] = useState("");



  const [userRoles, setUserRoles] = useState([]);

  const [rolesLoading, setRolesLoading] = useState(false);



  const [pageNumber, setPageNumber] = useState(1);

  const [totalRecords, setTotalRecords] = useState(0);

  const [usersLoading, setUsersLoading] = useState(false);



  const [modalOpen, setModalOpen] = useState(false);

  const [editing, setEditing] = useState(null);

  const [form, setForm] = useState({ ...EMPTY_FORM });



  const [selectedView, setSelectedView] = useState(null);

  const [deleteTarget, setDeleteTarget] = useState(null);



  const [showPassword, setShowPassword] = useState(false);

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [profilePreview, setProfilePreview] = useState("");



  const [notification, setNotification] = useState(null);



  const showNotification = (type, message) => {

    setNotification({

      type,

      message,

    });

  };



  useEffect(() => {

    if (!notification) return;



    const timer = setTimeout(() => {

      setNotification(null);

    }, 3000);



    return () => clearTimeout(timer);

  }, [notification]);



  const getUserRoleName = (user) => {

    if (user?.role) {

      return user.role;

    }



    const matchedRole = userRoles.find(

      (role) =>

        Number(role.id) ===

        Number(user?.roleId)

    );



    return matchedRole?.name ?? "";

  };



  const loadUserRoles = useCallback(

    async () => {

      try {

        setRolesLoading(true);



        const response = await apiService.get(

          GET_ALL_USER_ROLES_API,

          {

            includeInActive: true,

          }

        );



        const result = response.data;



        console.log(

          "Get All User Roles Response:",

          result

        );



        const output =

          result?.output ??

          result?.Output ??

          result?.data ??

          result?.Data ??

          result;



        const roleResult =

          Array.isArray(output)

            ? output

            : Array.isArray(output?.result)

              ? output.result

              : Array.isArray(output?.Result)

                ? output.Result

                : Array.isArray(output?.data)

                  ? output.data

                  : Array.isArray(output?.Data)

                    ? output.Data

                    : [];



        const normalizedRoles =

          roleResult.map((role) => ({

            ...role,



            id:

              role?.id ??

              role?.Id ??

              role?.userRoleId ??

              role?.UserRoleId,



            name:

              role?.roleName ??

              role?.RoleName ??

              role?.name ??

              role?.Name ??

              "",

          }));



        setUserRoles(

          normalizedRoles

        );



      } catch (error) {

        console.error(

          "Get All User Roles API Error:",

          error

        );



        setUserRoles([]);

      } finally {

        setRolesLoading(false);

      }

    },

    []

  );





  useEffect(() => {

    loadUserRoles();

  }, [loadUserRoles]);





  const loadUsers = useCallback(

    async (

      currentPage = 1,

      searchValue = "",

      signal = undefined

    ) => {

      try {

        setUsersLoading(true);



        const requestBody = {

          Page: currentPage,

          PageSize: PAGE_SIZE,

          SearchTerm: searchValue.trim(),

          SortDirection: "DESC",

          SortField: "Id",

        };



        console.log(

          "Get Paginated Users Request:",

          requestBody

        );



        const response = await apiService.post(

          GET_PAGINATED_USERS_API,

          requestBody

        );



        const result = response.data;



        console.log(

          "Get Paginated Users Response:",

          result

        );



        const output =

          result?.output ??

          result?.Output ??

          result?.data ??

          result?.Data ??

          result;



        const userResult =

          Array.isArray(output)

            ? output

            : Array.isArray(output?.result)

              ? output.result

              : Array.isArray(output?.Result)

                ? output.Result

                : Array.isArray(output?.data)

                  ? output.data

                  : Array.isArray(output?.Data)

                    ? output.Data

                    : [];



        const rowCountValue =

          output?.rowCount ??

          output?.RowCount ??

          output?.totalRecords ??

          output?.TotalRecords ??

          userResult.length;



        const normalizedUsers =

          userResult.map(normalizeUser);



        const visibleUsers =

          normalizedUsers.filter(

            (user) => user.active

          );



        const usersWithDisplayId =

          visibleUsers.map(

            (user, index) => ({

              ...user,

              displayId:

                (currentPage - 1) *

                PAGE_SIZE +

                index +

                1,

            })

          );



        setUsers(usersWithDisplayId);



        // Use server-side total count; current page length is at most PAGE_SIZE.
        setTotalRecords(Number(rowCountValue) || usersWithDisplayId.length);



      } catch (error) {

        if (

          error?.name ===

          "AbortError"

        ) {

          return;

        }



        console.error(

          "Get Paginated Users API Error:",

          error

        );



        setUsers([]);

        setTotalRecords(0);



      } finally {

        if (!signal?.aborted) {

          setUsersLoading(false);

        }

      }

    },

    []

  );





  /* ================= PAGINATION ================= */



  const totalPages = Math.max(

    1,

    Math.ceil(totalRecords / PAGE_SIZE)

  );



  const pageNumbers = Array.from(

    { length: totalPages },

    (_, index) => index + 1

  );



  const paginatedUsers = useMemo(

    () => users,

    [users]

  );



  useEffect(() => {

    setPageNumber(1);

  }, [search]);



  useEffect(() => {

    if (pageNumber > totalPages) {

      setPageNumber(totalPages);

    }

  }, [pageNumber, totalPages]);





  /* ================= LOAD USERS ================= */



  useEffect(() => {

    const controller =

      new AbortController();



    const timer =

      setTimeout(() => {

        loadUsers(

          pageNumber,

          search,

          controller.signal

        );

      }, 300);



    return () => {

      clearTimeout(timer);

      controller.abort();

    };

  }, [

    pageNumber,

    search,

    loadUsers,

  ]);





  /* ================= OPEN ADD ================= */



  const openAdd = () => {

    setEditing(null);

    setForm({ ...EMPTY_FORM });

    setProfilePreview("");

    setShowPassword(false);

    setShowConfirmPassword(false);

    setNotification(null);

    setModalOpen(true);

  };





  /* ================= OPEN EDIT ================= */



  const openEdit = (user) => {

    setEditing(user);



    setForm({

      ...EMPTY_FORM,

      firstName: user.firstName,

      middleName: user.middleName,

      lastName: user.lastName,

      email: user.email,

      mobile: user.mobile,



      role:

        user.roleId ||

        userRoles.find(

          (role) => role.name === user.role

        )?.id ||

        "",



      dob: user.dob

        ? user.dob.split("-").reverse().join("-")

        : "",



      profilePic: user.profilePic || "",

    });



    setProfilePreview(

      user.profilePic?.startsWith("http") ||

        user.profilePic?.startsWith("data:image")

        ? user.profilePic

        : ""

    );



    setNotification(null);

    setModalOpen(true);

  };





  /* ================= OPEN VIEW ================= */



  const openView = (user) => {

    setSelectedView(user);

  };





  /* ================= UPDATE FIELD ================= */



  const updateField = (event) => {

    const { name, value } = event.target;



    setForm((prev) => ({

      ...prev,

      [name]: value,

    }));

  };





  /* ================= PROFILE IMAGE ================= */



  const handleProfilePicChange = (event) => {

    const file = event.target.files?.[0];



    if (!file) {

      setForm((prev) => ({

        ...prev,

        profilePic: "",

      }));



      setProfilePreview("");

      return;

    }



    if (!file.type.startsWith("image/")) {

      showNotification(

        "error",

        "Please select an image file."

      );



      event.target.value = "";

      return;

    }



    if (file.size > 500 * 1024) {

      showNotification(

        "error",

        "Profile picture size must be 500 KB or less."

      );



      event.target.value = "";



      setForm((prev) => ({

        ...prev,

        profilePic: "",

      }));



      setProfilePreview("");

      return;

    }



    const imagePath =

      event.target.value || file.name;



    setForm((prev) => ({

      ...prev,

      profilePic: imagePath,

    }));



    setProfilePreview(

      URL.createObjectURL(file)

    );

  };





  /* ================= ADD / EDIT SUBMIT ================= */



  const handleSubmit = async (event) => {

    event.preventDefault();



    if (

      !editing &&

      (

        !form.firstName.trim() ||

        !form.middleName.trim() ||

        !form.lastName.trim() ||

        !form.email.trim() ||

        !form.mobile.trim() ||

        !form.role ||

        !form.dob ||

        !form.profilePic ||

        !form.password ||

        !form.confirmPassword

      )

    ) {

      showNotification(

        "error",

        "Please fill all fields."

      );



      return;

    }



    if (

      editing &&

      (

        !form.firstName.trim() ||

        !form.middleName.trim() ||

        !form.lastName.trim() ||

        !form.email.trim() ||

        !form.mobile.trim() ||

        !form.role ||

        !form.dob

      )

    ) {

      showNotification(

        "error",

        "Please fill all fields."

      );



      return;

    }



    if (

      !editing &&

      form.password !== form.confirmPassword

    ) {

      showNotification(

        "error",

        "Password and Confirm Password must match."

      );



      return;

    }





    /* =====================================================

       EDIT USER - BACKEND API

    ===================================================== */



    if (editing) {

      try {

        const userId = Number(

          editing?.id ??

          editing?.Id

        );



        if (!userId || Number.isNaN(userId)) {

          showNotification(

            "error",

            "Invalid User Id."

          );



          return;

        }



        const refreshTokenExpiryTime =

          editing?.refreshTokenExpiryTime ??

          editing?.RefreshTokenExpiryTime ??

          new Date(

            Date.now() +

            7 * 24 * 60 * 60 * 1000

          ).toISOString();



        const apiPayload = {

          Id: userId,



          FirstName:

            form.firstName.trim(),



          MiddleName:

            form.middleName.trim(),



          LastName:

            form.lastName.trim(),



          Email:

            form.email.trim(),



          MobileNo:

            form.mobile.trim(),



          DateOfBirth:

            `${form.dob}T00:00:00`,



          Hash:

            editing?.hash ??

            editing?.Hash ??

            "",



          Salt:

            editing?.salt ??

            editing?.Salt ??

            "",



          Token:

            editing?.token ??

            editing?.Token ??

            "",



          RefreshToken:

            editing?.refreshToken ??

            editing?.RefreshToken ??

            "",



          IsPasswordSet:

            editing?.isPasswordSet ??

            editing?.IsPasswordSet ??

            false,



          IsFirstTime:

            editing?.isFirstTime ??

            editing?.IsFirstTime ??

            false,



          Role:

            Number(form.role),



          ProfilePic:

            form.profilePic ||

            editing.profilePic ||

            "",



          RefreshTokenExpiryTime:

            refreshTokenExpiryTime,



          IsActive:

            editing.active ? 1 : 0,

        };



        console.log(

          "Update User Request:",

          apiPayload

        );



        await apiService.put(

          "User/updateUser",

          apiPayload

        );



        setModalOpen(false);

        setEditing(null);



        await loadUsers(

          pageNumber,

          search

        );



        showNotification(

          "success",

          "User updated successfully."

        );



      } catch (error) {

        console.error(

          "Update User API Error:",

          error

        );



        showNotification(

          "error",

          error?.response?.data?.failureReason ||

          error?.response?.data?.FailureReason ||

          error?.response?.data?.message ||

          error?.response?.data?.Message ||

          error?.message ||

          "Failed to update user"

        );

      }



      return;

    }





    /* =====================================================

       ADD USER - BACKEND API

    ===================================================== */



    try {

      const refreshTokenExpiryTime =

        new Date();



      refreshTokenExpiryTime.setDate(

        refreshTokenExpiryTime.getDate() + 7

      );



      const apiPayload = {

        FirstName:

          form.firstName.trim(),



        MiddleName:

          form.middleName.trim(),



        LastName:

          form.lastName.trim(),



        Email:

          form.email.trim(),



        Password:

          form.password,



        MobileNo:

          form.mobile.trim(),



        DateOfBirth:

          form.dob

            ? `${form.dob}T00:00:00`

            : null,



        Role:

          Number(form.role),



        Hash: null,

        Salt: null,

        Token: null,

        RefreshToken: null,



        RefreshTokenExpiryTime:

          refreshTokenExpiryTime.toISOString(),



        ProfilePic:

          form.profilePic,



        IsActive: 1,

      };



      console.log(

        "Add User Request:",

        apiPayload

      );



      await apiService.post(

        "User/addUser",

        apiPayload

      );



      setSearch("");

      setPageNumber(1);

      setModalOpen(false);

      setEditing(null);



      await loadUsers(

        1,

        ""

      );



      showNotification(

        "success",

        "User added successfully."

      );



    } catch (error) {

      console.error(

        "Add User API Error:",

        error

      );



      showNotification(

        "error",

        error?.response?.data?.failureReason ||

        error?.response?.data?.FailureReason ||

        error?.response?.data?.message ||

        error?.response?.data?.Message ||

        error?.message ||

        "Failed to add user"

      );

    }

  };





  /* ================= DELETE USER ================= */



  const confirmDelete = async () => {

    if (!deleteTarget) return;



    const userId = Number(

      deleteTarget?.id ??

      deleteTarget?.Id

    );



    if (!userId || Number.isNaN(userId)) {

      showNotification(

        "error",

        "Invalid User Id."

      );



      return;

    }



    try {

      console.log(

        "Delete User Id:",

        userId

      );



      await apiService.delete(

        `User/DeleteUser/${userId}`

      );



      setUsers((prev) =>

        prev

          .filter(

            (user) =>

              Number(user.id) !== userId

          )

          .map(

            (user, index) => ({

              ...user,



              displayId:

                (pageNumber - 1) *

                PAGE_SIZE +

                index +

                1,

            })

          )

      );



      setTotalRecords((prev) =>

        Math.max(

          0,

          Number(prev) - 1

        )

      );



      const moveToPreviousPage =

        pageNumber > 1 &&

        users.length === 1;



      setDeleteTarget(null);



      if (moveToPreviousPage) {

        setPageNumber(

          (prev) =>

            Math.max(

              1,

              prev - 1

            )

        );

      }



      showNotification(

        "success",

        "User deleted successfully."

      );



    } catch (error) {

      console.error(

        "Delete User API Error:",

        error

      );



      showNotification(

        "error",

        error?.response?.data?.failureReason ||

        error?.response?.data?.FailureReason ||

        error?.response?.data?.message ||

        error?.response?.data?.Message ||

        error?.message ||

        "Failed to delete user"

      );

    }

  };





  /* ================= VIEW PAGE ================= */



  if (selectedView) {

    return (

      <div className="um-page">
      <style>{`
        .um-page { min-width: 0; max-width: 100%; }
        .um-page .um-card { min-width: 0; max-width: 100%; }
        .um-pagination-footer { box-sizing: border-box; }
        .um-pagination-controls > button { flex: 0 0 auto; }
        .um-pagination-numbers > button { flex: 0 0 auto; }
        @media (max-width: 650px) {
          .um-pagination-footer { flex-direction: column; align-items: stretch !important; }
          .um-pagination-count { width: 100%; }
          .um-pagination-controls { width: 100%; flex: 0 0 auto !important; justify-content: space-between !important; }
          .um-pagination-controls > button { min-width: 54px !important; padding: 0 7px !important; }
          .um-pagination-numbers { flex: 1 1 0 !important; }
          .um-pagination-numbers > button { min-width: 30px !important; padding: 0 7px !important; }
        }
      `}</style>

      {/* ================= NOTIFICATION ================= */}



        <div className="um-card">



          <div className="um-card-head">



            <h2>View User</h2>



            <button

              className="um-primary-btn"

              onClick={() =>

                setSelectedView(null)

              }

            >

              <ArrowLeft size={17} />



              Back

            </button>



          </div>





          <div className="um-modal-body">



            <div className="um-grid-3">



              <label className="um-field">

                <span>Id</span>



                <input

                  value={

                    selectedView.displayId

                  }

                  readOnly

                />

              </label>





              <label className="um-field">

                <span>First Name</span>



                <input

                  value={

                    selectedView.firstName

                  }

                  readOnly

                />

              </label>





              <label className="um-field">

                <span>Middle Name</span>



                <input

                  value={

                    selectedView.middleName

                  }

                  readOnly

                />

              </label>





              <label className="um-field">

                <span>Last Name</span>



                <input

                  value={

                    selectedView.lastName

                  }

                  readOnly

                />

              </label>





              <label className="um-field">

                <span>Email</span>



                <input

                  value={

                    selectedView.email

                  }

                  readOnly

                />

              </label>





              <label className="um-field">

                <span>Mobile Number</span>



                <input

                  value={

                    selectedView.mobile

                  }

                  readOnly

                />

              </label>





              <label className="um-field">

                <span>Date Of Birth</span>



                <input

                  value={

                    selectedView.dob

                  }

                  readOnly

                />

              </label>





              <label className="um-field">

                <span>Role</span>



                <input

                  value={

                    getUserRoleName(

                      selectedView

                    )

                  }

                  readOnly

                />

              </label>





              <label className="um-field">



                <span>

                  Profile Picture

                </span>



                {selectedView.profilePic ? (



                  <img

                    src={

                      selectedView.profilePic

                    }

                    alt="Profile"

                    style={{

                      width: "60px",

                      height: "60px",

                      objectFit: "cover",

                      borderRadius: "50%",

                      border:

                        "1px solid #e2e8f0",

                    }}

                  />



                ) : (



                  <input

                    value=""

                    readOnly

                  />



                )}



              </label>





              <label className="um-field">



                <span>Active</span>



                <input

                  value={

                    selectedView.active

                      ? "Yes"

                      : "No"

                  }

                  readOnly

                />



              </label>



            </div>



          </div>



        </div>



      </div>

    );

  }





  /* ================= MAIN PAGE ================= */



  return (

    <div className="um-page">





      {/* ================= NOTIFICATION ================= */}



      {notification && (



        <div

          style={{

            position: "fixed",



            top: "20px",

            right: "20px",



            zIndex: 99999,



            minWidth: "280px",

            maxWidth: "420px",



            padding:

              "12px 16px",



            borderRadius:

              "8px",



            backgroundColor:

              notification.type === "success"

                ? "#d1e7dd"

                : "#f8d7da",



            color:

              notification.type === "success"

                ? "#0f5132"

                : "#842029",



            border:

              notification.type === "success"

                ? "1px solid #badbcc"

                : "1px solid #f5c2c7",



            fontSize:

              "14px",



            fontWeight:

              600,



            boxShadow:

              "0 4px 12px rgba(0,0,0,0.15)",

          }}

        >



          {notification.type === "success"

            ? "✓ "

            : "✕ "}



          {notification.message}



        </div>



      )}





      <div className="um-card">





        {/* ================= HEADER ================= */}



        <div className="um-card-head">



          <h2>User List</h2>





          <div className="um-head-actions">



            <button

              className="um-primary-btn"

              onClick={openAdd}

            >

              <Plus size={17} />



              Add New User

            </button>





            <label className="um-search">



              <Search size={17} />



              <input

                value={search}

                onChange={(e) =>

                  setSearch(

                    e.target.value

                  )

                }

                placeholder="Search..."

              />



            </label>



          </div>



        </div>





        {/* ================= USER TABLE ================= */}



        <div className="um-table-wrap">



          <table className="um-table">



            <thead>



              <tr>



                <th>Id</th>



                <th>

                  First Name

                </th>



                <th>

                  Middle Name

                </th>



                <th>

                  Last Name

                </th>



                <th>Email</th>



                <th>

                  Mobile No

                </th>



                <th>

                  Date Of Birth

                </th>



                <th>Role</th>



                <th>Active</th>



                <th>Actions</th>



              </tr>



            </thead>





            <tbody>





              {usersLoading ? (



                <tr>



                  <td

                    colSpan="10"

                    style={{

                      textAlign:

                        "center",



                      padding:

                        "28px",



                      color:

                        "var(--t3)",

                    }}

                  >

                    Loading users...

                  </td>



                </tr>





              ) : paginatedUsers.length === 0 ? (



                <tr>



                  <td

                    colSpan="10"

                    style={{

                      textAlign:

                        "center",



                      padding:

                        "28px",



                      color:

                        "var(--t3)",

                    }}

                  >

                    No users found

                  </td>



                </tr>





              ) : (



                paginatedUsers.map(

                  (user) => (



                    <tr

                      key={user.id}

                    >



                      <td>

                        {user.displayId}

                      </td>



                      <td>

                        {user.firstName}

                      </td>



                      <td>

                        {user.middleName}

                      </td>



                      <td>

                        {user.lastName}

                      </td>



                      <td>

                        {user.email}

                      </td>



                      <td>

                        {user.mobile}

                      </td>



                      <td>

                        {user.dob}

                      </td>



                      <td>

                        {getUserRoleName(

                          user

                        )}

                      </td>



                      <td>

                        {user.active

                          ? "Yes"

                          : "No"}

                      </td>





                      <td>



                        <div className="ra">





                          {/* VIEW */}



                          <button

                            type="button"



                            className="

                              btn

                              btn-p

                              btn-sm

                            "



                            title="View"



                            onClick={() =>

                              setSelectedView(

                                user

                              )

                            }

                          >



                            <I

                              n="eye"

                              s={11}

                              c="#fff"

                            />



                          </button>





                          {/* EDIT */}



                          <button

                            type="button"



                            className="

                              btn

                              btn-g

                              btn-sm

                            "



                            title="Edit"



                            onClick={() =>

                              openEdit(

                                user

                              )

                            }

                          >



                            <I

                              n="edit"

                              s={11}

                            />



                          </button>





                          {/* DELETE */}



                          <button

                            type="button"



                            className="

                              btn

                              btn-d

                              btn-sm

                            "



                            title="Delete"



                            onClick={() =>

                              setDeleteTarget(

                                user

                              )

                            }

                          >



                            <I

                              n="trash"

                              s={11}

                            />



                          </button>





                        </div>



                      </td>



                    </tr>



                  )

                )



              )}





            </tbody>



          </table>



        </div>





        {/* =====================================================

            PAGINATION

        ===================================================== */}



        {totalRecords > 0 && (



          <div

            style={{

              width: "100%",



              display: "flex",



              alignItems:

                "center",



              justifyContent:

                "space-between",



              gap: "16px",



              marginTop:

                "16px",



              padding:

                "12px 4px 4px",



              borderTop:

                "1px solid #eef2f7",

            }}

          >





            {/* LEFT COUNT */}

            <div className="um-pagination-count"

              style={{

                display: "flex",



                alignItems:

                  "center",



                whiteSpace:

                  "nowrap",



                fontSize:

                  "11px",



                lineHeight:

                  "16px",



                color:

                  "var(--t3)",

              }}

            >



              Showing{" "}



              <span

                style={{

                  margin:

                    "0 4px",



                  fontWeight:

                    600,



                  color:

                    "var(--t2)",

                }}

              >



                {(pageNumber - 1) *

                  PAGE_SIZE +

                  1}



              </span>





              –





              <span

                style={{

                  margin:

                    "0 4px",



                  fontWeight:

                    600,



                  color:

                    "var(--t2)",

                }}

              >



                {Math.min(

                  pageNumber *

                  PAGE_SIZE,



                  totalRecords

                )}



              </span>





              {" "}of{" "}





              <span

                style={{

                  marginLeft:

                    "4px",



                  fontWeight:

                    600,



                  color:

                    "var(--t2)",

                }}

              >



                {totalRecords}



              </span>



            </div>





            {/* PAGINATION BUTTONS */}

            <div className="um-pagination-controls"

              style={{

                display:

                  "flex",



                alignItems:

                  "center",



                gap: "5px",
                flex: "1 1 240px",
                minWidth: 0,
                maxWidth: "100%",
                justifyContent: "flex-end",
                overflow: "hidden",
              }}

            >





              {/* BACK */}



              <button

                type="button"



                disabled={

                  pageNumber === 1

                }



                onClick={() =>

                  setPageNumber(

                    (previous) =>

                      Math.max(

                        1,

                        previous - 1

                      )

                  )

                }



                style={{

                  height:

                    "32px",



                  minWidth:

                    "66px",



                  padding:

                    "0 10px",



                  display:

                    "inline-flex",



                  alignItems:

                    "center",



                  justifyContent:

                    "center",



                  gap:

                    "3px",



                  border:

                    "1px solid #e2e8f0",



                  borderRadius:

                    "6px",



                  background:

                    pageNumber === 1

                      ? "#f8fafc"

                      : "#fff",



                  color:

                    pageNumber === 1

                      ? "#cbd5e1"

                      : "#475569",



                  fontSize:

                    "11px",



                  fontWeight:

                    500,



                  cursor:

                    pageNumber === 1

                      ? "not-allowed"

                      : "pointer",



                  transition:

                    "all 0.15s ease",

                }}

              >



                <span

                  style={{

                    fontSize:

                      "16px",



                    lineHeight:

                      1,

                  }}

                >

                  ‹

                </span>



                Back



              </button>





              {/* PAGE NUMBERS */}

              <div className="um-pagination-numbers"

                style={{

                  display:

                    "flex",



                  alignItems:

                    "center",



                  gap: "4px",
                  flex: "0 1 auto",
                  minWidth: 0,
                  maxWidth: "100%",
                  overflowX: "auto",
                  overflowY: "hidden",
                  WebkitOverflowScrolling: "touch",
                  overscrollBehaviorX: "contain",
                  scrollbarWidth: "thin",
                }}

              >



                {pageNumbers.map(

                  (page) => (



                    <button

                      key={page}



                      type="button"



                      onClick={() =>

                        setPageNumber(

                          page

                        )

                      }



                      style={{

                        height:

                          "32px",



                        minWidth:

                          "32px",



                        padding:

                          "0 9px",



                        display:

                          "inline-flex",



                        alignItems:

                          "center",



                        justifyContent:

                          "center",



                        border:

                          pageNumber === page

                            ? "1px solid #2563eb"

                            : "1px solid #e2e8f0",



                        borderRadius:

                          "6px",



                        background:

                          pageNumber === page

                            ? "#2563eb"

                            : "#fff",



                        color:

                          pageNumber === page

                            ? "#fff"

                            : "#475569",



                        fontSize:

                          "11px",



                        fontWeight:

                          600,



                        cursor:

                          "pointer",



                        transition:

                          "all 0.15s ease",

                      }}

                    >



                      {page}



                    </button>



                  )

                )}



              </div>





              {/* NEXT */}



              <button

                type="button"



                disabled={

                  pageNumber >=

                  totalPages

                }



                onClick={() =>

                  setPageNumber(

                    (previous) =>

                      Math.min(

                        totalPages,

                        previous + 1

                      )

                  )

                }



                style={{

                  height:

                    "32px",



                  minWidth:

                    "66px",



                  padding:

                    "0 10px",



                  display:

                    "inline-flex",



                  alignItems:

                    "center",



                  justifyContent:

                    "center",



                  gap:

                    "3px",



                  border:

                    "1px solid #e2e8f0",



                  borderRadius:

                    "6px",



                  background:

                    pageNumber >=

                      totalPages

                      ? "#f8fafc"

                      : "#fff",



                  color:

                    pageNumber >=

                      totalPages

                      ? "#cbd5e1"

                      : "#475569",



                  fontSize:

                    "11px",



                  fontWeight:

                    500,



                  cursor:

                    pageNumber >=

                      totalPages

                      ? "not-allowed"

                      : "pointer",



                  transition:

                    "all 0.15s ease",

                }}

              >



                Next



                <span

                  style={{

                    fontSize:

                      "16px",



                    lineHeight:

                      1,

                  }}

                >

                  ›

                </span>



              </button>



            </div>



          </div>



        )}



      </div>





      {/* =====================================================

          ADD / EDIT POPUP

      ===================================================== */}



      {modalOpen && (



        <div

          className="um-modal-backdrop"



          onMouseDown={() =>

            setModalOpen(false)

          }

        >



          <form

            className="

              um-modal

              um-modal-user

            "



            onSubmit={

              handleSubmit

            }



            onMouseDown={(e) =>

              e.stopPropagation()

            }

          >





            {/* HEADER */}



            <div className="um-modal-head">



              <h3>



                {editing

                  ? "Edit User"

                  : "Add New User"}



              </h3>





              <button

                type="button"



                className="

                  um-close-btn

                "



                onClick={() =>

                  setModalOpen(

                    false

                  )

                }

              >



                <X size={20} />



              </button>



            </div>





            {/* BODY */}



            <div className="um-modal-body">





              <div className="um-grid-3">





                {/* FIRST NAME */}



                <label className="um-field">



                  <span>

                    First Name

                  </span>



                  <input

                    name="firstName"



                    value={

                      form.firstName

                    }



                    onChange={

                      updateField

                    }



                    placeholder="

                      First Name

                    "

                  />



                </label>





                {/* MIDDLE NAME */}



                <label className="um-field">



                  <span>

                    Middle Name

                  </span>



                  <input

                    name="middleName"



                    value={

                      form.middleName

                    }



                    onChange={

                      updateField

                    }



                    placeholder="

                      Middle Name

                    "

                  />



                </label>





                {/* LAST NAME */}



                <label className="um-field">



                  <span>

                    Last Name

                  </span>



                  <input

                    name="lastName"



                    value={

                      form.lastName

                    }



                    onChange={

                      updateField

                    }



                    placeholder="

                      Last Name

                    "

                  />



                </label>



              </div>





              <div className="um-grid-2">





                {/* EMAIL */}



                <label className="um-field">



                  <span>Email</span>



                  <input

                    type="email"



                    name="email"



                    value={

                      form.email

                    }



                    onChange={

                      updateField

                    }



                    placeholder="

                      Email

                    "

                  />



                </label>





                {/* MOBILE */}



                <label className="um-field">



                  <span>

                    Mobile Number

                  </span>



                  <input

                    name="mobile"



                    value={

                      form.mobile

                    }



                    onChange={

                      updateField

                    }



                    placeholder="

                      Mobile Number

                    "



                    maxLength={10}

                  />



                </label>





                {/* ROLE */}



                <label className="um-field">



                  <span>Role</span>



                  <select

                    name="role"



                    value={

                      form.role

                    }



                    onChange={

                      updateField

                    }



                    disabled={

                      rolesLoading

                    }

                  >



                    <option value="">



                      {rolesLoading

                        ? "Loading Roles..."

                        : "Select a Role"}



                    </option>





                    {userRoles.map(

                      (role) => (



                        <option

                          key={

                            role.id

                          }



                          value={

                            role.id

                          }

                        >



                          {role.name}



                        </option>



                      )

                    )}



                  </select>



                </label>





                {/* DOB */}



                <label className="um-field">



                  <span>

                    Date Of Birth

                  </span>



                  <input

                    type="date"

                    name="dob"

                    value={form.dob}

                    onChange={updateField}

                    max={new Date().toISOString().split("T")[0]}

                  />



                </label>





                {/* PROFILE PICTURE */}



                <label className="um-field">



                  <span>

                    Profile Picture

                  </span>



                  <input

                    type="file"



                    accept="image/*"



                    onChange={

                      handleProfilePicChange

                    }

                  />





                  {profilePreview && (



                    <img

                      src={

                        profilePreview

                      }



                      alt="

                        Profile Preview

                      "



                      style={{

                        width:

                          "60px",



                        height:

                          "60px",



                        objectFit:

                          "cover",



                        borderRadius:

                          "50%",



                        marginTop:

                          "8px",



                        border:

                          "1px solid #e2e8f0",

                      }}

                    />



                  )}



                </label>





                {/* PASSWORD */}



                {/* PASSWORD */}



                {!editing && (

                  <>

                    <label className="um-field">

                      <span>Password</span>



                      <div className="um-password">

                        <input

                          type={showPassword ? "text" : "password"}

                          name="password"

                          value={form.password}

                          onChange={updateField}

                          placeholder="Password"

                        />



                        <button

                          type="button"

                          onClick={() =>

                            setShowPassword((prev) => !prev)

                          }

                        >

                          {showPassword ? (

                            <EyeOff size={18} />

                          ) : (

                            <Eye size={18} />

                          )}

                        </button>

                      </div>

                    </label>



                    {/* CONFIRM PASSWORD */}



                    <label className="um-field">

                      <span>Confirm Password</span>



                      <div className="um-password">

                        <input

                          type={showConfirmPassword ? "text" : "password"}

                          name="confirmPassword"

                          value={form.confirmPassword}

                          onChange={updateField}

                          placeholder="Confirm Password"

                        />



                        <button

                          type="button"

                          onClick={() =>

                            setShowConfirmPassword((prev) => !prev)

                          }

                        >

                          {showConfirmPassword ? (

                            <EyeOff size={18} />

                          ) : (

                            <Eye size={18} />

                          )}

                        </button>

                      </div>

                    </label>

                  </>

                )}



              </div>



            </div>





            {/* FOOTER */}



            <div className="um-modal-foot">



              <button

                type="button"



                className="

                  um-cancel-btn

                "



                onClick={() =>

                  setModalOpen(

                    false

                  )

                }

              >



                Cancel



              </button>





              <button

                type="submit"



                className="

                  um-primary-btn

                "

              >



                {editing

                  ? "Update"

                  : "Add"}



              </button>



            </div>



          </form>



        </div>



      )}





      {/* =====================================================

          DELETE POPUP

      ===================================================== */}



      {deleteTarget && (



        <div

          className="

            um-modal-backdrop

          "



          onMouseDown={() =>

            setDeleteTarget(

              null

            )

          }

        >



          <div

            className="

              um-modal

              um-modal-role

            "



            onMouseDown={(e) =>

              e.stopPropagation()

            }

          >





            <div className="um-modal-head">



              <h3>

                Delete User

              </h3>





              <button

                type="button"



                className="

                  um-close-btn

                "



                onClick={() =>

                  setDeleteTarget(

                    null

                  )

                }

              >



                <X size={20} />



              </button>



            </div>





            <div className="um-modal-body">



              <p>



                Are you sure you want to delete{" "}



                <strong>



                  {deleteTarget.firstName}{" "}



                  {deleteTarget.lastName}



                </strong>



                ?



              </p>



            </div>





            <div className="um-modal-foot">



              <button

                type="button"



                className="

                  um-cancel-btn

                "



                onClick={() =>

                  setDeleteTarget(

                    null

                  )

                }

              >



                Cancel



              </button>





              <button

                type="button"



                className="

                  um-primary-btn

                "



                onClick={

                  confirmDelete

                }

              >



                Delete



              </button>



            </div>



          </div>



        </div>



      )}



    </div>

  );

}